import type { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "axios";
import axiosRetry from "axios-retry";
import {
  reqErrHandler,
  reqHandler,
  resErrHandler,
  resHandler
} from "@util/net/interceptors";
import { REQUEST_TIMEOUT } from "@util/config";
import { getRegionFromUrl, getBrand } from "@util/common";
import {
  convertRegionName,
  isEUCountry,
  isUgcNeedWaveTwoCountry,
  convertEUMinorRegionName
} from "@util/country";
import store from "../../redux/store";

const handleClientId = () =>
  `${getBrand().toLowerCase()}${convertRegionName(
    getRegionFromUrl()
  )}-sth-is-proxy`;

let headers;
if (isUgcNeedWaveTwoCountry(getRegionFromUrl())) {
  headers = {
    "x-fr-clientid": handleClientId(),
    "X-UGC-Use-Wave2-For": `UNIQLO_${convertEUMinorRegionName(
      getRegionFromUrl()
    ).toLocaleUpperCase()}`
  };
} else {
  headers = {
    "x-fr-clientid": handleClientId()
  };
}

const instance = axios.create({
  timeout: REQUEST_TIMEOUT,
  headers
});
axiosRetry(instance, {
  retries: 2,
  retryDelay: (retryCount) => retryCount * 1000
});
// add interceptors
instance.interceptors.request.use(reqHandler, reqErrHandler);
instance.interceptors.response.use(resHandler, resErrHandler);
const get = async (
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const { region } = store.getState().app;
  let api = "";
  if (isEUCountry(region)) {
    api = `/${convertRegionName(region)}/api/ugc-proxy/v2/item/visual-search`;
  } else {
    api = `/ugc/api/v2/${getBrand().toLowerCase()}/${convertRegionName(
      region
    )}${url}`;
  }
  const response = await instance.get(api, config);
  return response;
};
const post = async (url: string, params?: any): Promise<AxiosResponse> => {
  const { region } = store.getState().app;
  let api = "";
  if (isEUCountry(region)) {
    api = `/${convertRegionName(region)}/api/ugc-proxy/v2/item/visual-search`;
  } else {
    api = `/ugc/api/v2/${getBrand().toLowerCase()}/${convertRegionName(
      region
    )}${url}`;
  }
  const response = await instance.post(api, params);
  return response;
};

const newGet = async (
  url: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse> => {
  const { region } = store.getState().app;
  let api = "";
  if (isEUCountry(region)) {
    api = `/${convertRegionName(region)}/api/ugc-proxy/v2/item/visual-search`;
  } else {
    api = `/api/ugc-proxy/v2/${getBrand().toLowerCase()}/${convertRegionName(
      region
    )}${url}`;
  }
  const response = await instance.get(api, config);
  return response;
};
const newPost = async (url: string, params?: any): Promise<AxiosResponse> => {
  const { region } = store.getState().app;
  let api = "";
  if (isEUCountry(region)) {
    api = `/${convertRegionName(region)}/api/ugc-proxy/v2/item/visual-search`;
  } else {
    // api = `/api/ugc-proxy/v2/${getBrand().toLowerCase()}/${convertRegionName(
    //   region
    // )}${url}`;
    api = `/${convertRegionName(region)}/api/ugc-proxy/v2${url}`;
  }
  const response = await instance.post(api, params);
  return response;
};

export default {
  get,
  post,
  newGet,
  newPost
};
